<template>
	<div class="padding-16 condition-border">
		<div  v-if="conditions" class="font-16 font-gilroy font-weight-500">
			<div>
				All employees that
				<match-button-group 
				@matchClicked="matchClickedCondition" v-if="conditions && conditions.condition_lines.length>1"
				:match_all="conditions.logic"></match-button-group>
			</div>
			<div v-for="(elem, index) in conditions.condition_lines" :key="index" class="flex">

				<a class="pointer mt-2" @click="removeFilterWho(index)">
								<img v-if="condition_connection_remove" class="mt-2 mr-2" width="16" height="16" src="../../../../assets/images/icons/solid/automation_remove_circle.svg"/>
				</a>

				<section v-if="condition_connection_remove && index != 0" class="mt-1 and_or_box font-16 font-weight-500"> {{conditions.logic}} </section>

				<who-condition-options
				:key="index" :index="index" :parent_index="parent_index" :update_flag="update_flag" 
				:who_selection="elem" :reset_option_available="reset_option_available"
				:automation_options="automation_options"
				 @updateConditionWho="updateConditionWho"
				 @dataUpdated="dataUpdated"
				 ></who-condition-options>

			</div>
			
			<section :class="{'input-disabled': !add_condition_available}" class="text-add-filter font-weight-500 font-gilroy font-16 pointer"> 
					<a  @click="addConditionWho()">
						<img class="" width="14" height="14" src="../../../../assets/images/icons/solid/automation_add_circle.svg"/>
					Add condition
					</a>
				</section>
			
		</div>
	</div>
	
</template>
<script>
import matchButtonGroup from '../../automationSharedView/matchButtonGroup.vue'
import whoConditionOptions from './whoConditionOptions.vue'
import automationMixin from '../../automationMixin'

export default {
	components : {
		matchButtonGroup,
		whoConditionOptions
	},
	props:{
		filter_selection:{
			type: Object,
			required: true
		},
		parent_index:{
			type: Number
		},
		connection_edit_text:{
			type: String
		},
		filter_updated:{
			type: Boolean,
			required: true,
		},
		edit:{
			type: Boolean,
			required: true,
		}
	},
	mixins: [
		automationMixin
	],
	data: function(){
		return{
			match_all: 'AND',
			conditions: null,
			add_condition_available: false,
			update_flag: false,
			reset_option_available: true,
			automation_options:[],
		}
	},
	mounted: function(){
	},
	computed:{
		condition_connection_remove(){
			return (this.conditions.condition_lines.length > 1)
		},
		getFilters(){
			let temp_ = this.$store.getters.getFilters
			if(temp_ && temp_.filters && temp_.filters.filter_lines && temp_.filters.filter_lines[this.parent_index].conditions){
				this.conditions = temp_.filters.filter_lines[this.parent_index].conditions

			}else{
				this.cleanMemory()
			}
			return this.$store.getters.getFilters
		}
	},
	beforeDestroy(){
		 this.$nextTick(() => {
			this.cleanMemory()
		})
	},
	watch:{
		filter_selection: {
			handler(val){
				if(val){
					this.conditions = val.conditions;
					this.$forceUpdate();
				}else{
					this.conditions = {
						logic : 'AND',
						condition_lines: [{
							rule_property_id: '',
							conditional_id: '',
							value:'',
							value_child:''
						}]
					}
				}
			},
			deep: true

		},
		getFilters: {
			handler(val){
			},
			deep: true

		},
		add_condition_available(val){
			this.$emit('addFilterAvailablity', val)
		},
		filter_updated(val){
			this.$nextTick(() => {
				this.conditions.condition_lines = this.filter_selection.conditions.condition_lines
				this.$forceUpdate()

			});
		},
		final_condition_api(val){
		},
		'conditions.condition_lines': {
			handler(val){
				this.$emit('updateFilterWho', val, this.parent_index, this.conditions.logic)
			},
			deep: true
		}
	},
	created(){
		this.getRules()

	},
	methods : {
		getRules(){
			var params = {
				filters:{
					organization_id : this.id
				}
			}
			this.$store.dispatch('getAutomationRules_Who', params).then((res) => {
				this.automation_options = res.data.data
			}).catch((error) => {
				console.log(error);
			});
		},
		matchClickedCondition(condition) {
			switch (condition){
				case 'any':
					this.match_all = false

					this.conditions.logic = 'OR'
					break;
				case 'all':
					this.match_all = true
					this.conditions.logic = 'AND'
					break;
			}
			this.$forceUpdate();
			this.$emit('updateFilterWho', this.conditions.condition_lines, this.parent_index, this.conditions.logic)


		},
		addConditionWho(){
			//let temp_index = this.condition_lines[this.condition_lines.length-1].rule_group.index
			this.conditions.condition_lines.push({
					rule_property_id:'',
					conditional_id:'',
					value:'',
					value_child:''
				
				})
			this.add_condition_available = false

		},
		updateConditionWho(new_condition, index){
		
			this.conditions.condition_lines[index] = new_condition
			this.$emit('updateFilterWho', this.conditions.condition_lines, this.parent_index, this.conditions.logic)
			this.validateCondition(new_condition)
		},
		dataUpdated(data_updated){
			this.reset_option_available = data_updated
		},
		removeFilterWho(index){
			this.$nextTick(() => {
				this.conditions.condition_lines.splice(index,1)
				this.update_flag = !this.update_flag
				this.$forceUpdate()
				this.add_condition_available = true
			});
			
		},
		validateCondition(condition){
			if(condition && condition.rule_property_id && condition.rule_property_id != ''  && condition.conditional_id != '' && condition.value != ''){
				this.add_condition_available = true
			}else{
				this.add_condition_available = false
			}
		},
		cleanMemory(){
			this.conditions = {
				logic : 'AND',
				condition_lines: [{
					rule_property_id: '',
					conditional_id: '',
					value:'',
					value_child:''
				}]
			}

		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/automation/automationGroups/WHO/conditionGroupWho.vue